// Apartments vs Offices — the one rule every screen uses to split a portfolio.
//
// Reads the DLD "Property Usage" a unit carries (`usage`, set in the CRM unit
// page), its sub-type, and the property TYPE picked when it was created
// ("Office" / "Retail" in the admin console — units made that way before the
// console set `usage` too landed in Apartments). Only an explicit commercial
// value makes a unit an office: no usage on file stays an apartment, and
// "Hotel" (serviced / hotel apartments) stays an apartment too.
export type UnitCategory = 'residential' | 'commercial';

export const unitCategory = (u: any): UnitCategory =>
  /commercial|office|retail|shop|warehouse/i.test(`${u?.usage || ''} ${u?.propertySubType || ''} ${u?.type || ''} ${u?.propertyType || ''}`)
    ? 'commercial'
    : 'residential';

/** True when a portfolio holds both kinds — the only case the split is shown. */
export const hasBothCategories = (units: any[]): boolean =>
  units.some((u) => unitCategory(u) === 'commercial') && units.some((u) => unitCategory(u) === 'residential');
